import { render } from "./beautyEdu.vue?vue&type=template&id=45687464&scoped=true"
import script from "./beautyEdu.vue?vue&type=script&lang=js"
export * from "./beautyEdu.vue?vue&type=script&lang=js"

import "./beautyEdu.vue?vue&type=style&index=0&id=45687464&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45687464"]])

export default __exports__